// extracted by mini-css-extract-plugin
export var container = "_dv-0";
export var popoverContent = "_dv-1";
export var tosLink = "_dv-2";